<template>
  <div class="coupon__item">
    <div class="coupon__item__content">
      <div class="coupon__item__content__top">
        <div>
          <span class="coupon__item__content__top__unit">¥</span>
          <span class="coupon__item__content__top__money">{{ item.amount }}</span>
        </div>
        <div class="coupon__item__content__top__desc">{{ item.name }}</div>
        <div class="point point__left"></div>
        <div class="point point__right"></div>
      </div>
      <div class="coupon__item__content__bottom">
        立即领取
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {}
  }
};
</script>

<style lang="scss" scoped>
.coupon__item {
  position: relative;
  width: 200px;
  height: 140px;
  background: linear-gradient(134deg, #fb6449 0%, #ff6144 43%, #fb9984 100%);
  border-radius: 8px;
  margin-bottom: 16px;
  margin-right: 32px;
  &__content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 184px;
    height: 124px;
    background: #ffffff;
    &__top {
      padding: 8px 0;
      margin: 0 12px;
      text-align: center;
      border-bottom: 1px dashed #ff4e47;
      &__unit {
        margin-right: 4px;
        font-size: 20px;
        font-weight: 500;
        color: #ff4e47;
        line-height: 1;
      }
      &__money {
        font-size: 48px;
        font-weight: 600;
        color: #ff4e47;
        line-height: 1;
      }
      &__desc {
        margin-top: 2px;
        font-size: 12px;
        font-weight: 400;
        color: #595959;
        line-height: 1;
      }
    }
    &__bottom {
      display: inline-block;
      width: 120px;
      height: 26px;
      position: absolute;
      left: 0;
      right: 0;
      margin: 10px auto auto auto;
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      color: #ff4e47;
      line-height: 26px;
      background: #fff1f1;
      border-radius: 13px;
    }
  }
  .point {
    position: absolute;
    bottom: 38px;
    width: 8px;
    height: 16px;
    background: linear-gradient(134deg, #fb6449 0%, #ff6144 43%, #fb9984 100%);
    &__left {
      border-radius: 0 16px 16px 0;
      left: -1px;
    }
    &__right {
      border-radius: 16px 0 0 16px;
      right: -1px;
    }
  }
}
</style>
